import React, { useState } from "react";
import "../ComponentCss/Contact.css";
import { Toaster } from "react-hot-toast";
import toast from "react-hot-toast";
import { ClipLoader } from "react-spinners";
import Header from "./Shared/Header";
import Footer from "./Shared/Footer";
import { post } from "../_services/apiService";
import { API_URL } from "../_services/apiUrl";
import Breadcrumb from "./Breadcrumb";

const ContactUs = () => {
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        mobile_number: "",
        subject: "",
        message: "",
    });

    const validatePhoneNumber = (phone) => {
        return /^[6-9]\d{9}$/.test(phone);
    };

    const validateEmail = (email) => {
        return /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/.test(email);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "mobile_number") {
            if (!/^[0-9]*$/.test(value)) {
                toast.error("Please enter only numbers for mobile number.");
                return;
            }
        }

        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const onSaveEnquiry = async (e) => {
        e.preventDefault();

        if (!formData.name.trim()) {
            toast.error("Please enter your name");
            return;
        }

        if (!formData.email.trim()) {
            toast.error("Please enter your email");
            return;
        }

        if (!validateEmail(formData.email)) {
            toast.error("Please enter a valid Email Address");
            return;
        }

        if (!formData.mobile_number.trim()) {
            toast.error("Please enter your mobile number");
            return;
        }

        if (!validatePhoneNumber(formData.mobile_number)) {
            toast.error("Please enter a valid mobile number");
            return;
        }

        if (!formData.subject.trim()) {
            toast.error("Please enter subject");
            return;
        }

        if (!formData.message.trim()) {
            toast.error("Please enter message");
            return;
        }

        setLoading(true);

        try {
            const payload = {
                name: formData.name,
                email: formData.email,
                mobile_number: formData.mobile_number,
                subject: formData.subject,
                message: formData.message,
            };


            const response = await post(API_URL.contactUs, payload);

            if (
                response?.isSuccess === 200 ||
                response?.status === 200 ||
                response?.message === "your_message_send_successfully"
            ) {
                toast.success("Your enquiry has been submitted successfully!");
                setFormData({
                    name: "",
                    email: "",
                    mobile_number: "",
                    subject: "",
                    message: "",
                });
            } else {
                toast.error(response?.message || "Something went wrong");
            }
        } catch (error) {

            if (error?.response?.data?.errors?.length > 0) {
                error.response.data.errors.forEach((err) => {
                    toast.error(err.message);
                });
            } else if (error?.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Please try again later.");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Toaster position="top-right" />
            <Header />

            {/* Contact Banner Section */}
            <section className="contact-banner-sec">
                <div className="container-fluid">
                    <div className="page-header">
                        <h1>Contact Us</h1>
                    </div>
                    <Breadcrumb />
                </div>
            </section>

            {/* Contact Details Section */}
            <section id="contact-page">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
                            <div className="contact-details text-center">
                                <i className="fa fa-envelope" aria-hidden="true"></i>
                                <h4 className="mb-0">Email Us</h4>
                                <p>Demo@gmail.com</p>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
                            <div className="contact-details text-center">
                                <i className="fa fa-location-pin" aria-hidden="true"></i>
                                <h4>Location</h4>
                                <p>1234 Elm Street Springfield Jaipur 302003</p>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
                            <div className="contact-details text-center">
                                <i className="fa fa-phone" aria-hidden="true"></i>
                                <h4>Phone</h4>
                                <p>+91 9878987898</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Google Map & Contact Form */}
            <section className="contact_sec">
                <div className="container">
                    <div className="row contact-main">
                        {/* Google Map */}
                        <div
                            className="col-lg-5 aos-init aos-animate"
                            data-aos="fade-right"
                        >
                            <div className="map">
                                <iframe
                                    title="Google Map"
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3557.890815209362!2d75.78707807612169!3d26.906960060336417!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396db35e704ce509%3A0x21a49e8d70a4d0!2siShivax!5e0!3m2!1sen!2sin!4v1733400909183!5m2!1sen!2sin"
                                    width="100%"
                                    height="450"
                                    style={{ border: 0 }}
                                    allowFullScreen=""
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                ></iframe>
                            </div>
                        </div>

                        {/* Contact Form */}
                        <div
                            className="col-lg-7 contact-form aos-init aos-animate pt-sm-0 pt-3"
                            data-aos="fade-left"
                        >
                            <div className="section-title">
                                <h3>Contact Us</h3>
                            </div>

                            <form onSubmit={onSaveEnquiry}>
                                <div className="row">
                                    <div className="col-md-6">
                                        <input
                                            type="text"
                                            placeholder="Name*"
                                            name="name"
                                            id="name"
                                            required
                                            value={formData.name}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <input
                                            type="email"
                                            placeholder="Email*"
                                            id="email"
                                            name="email"
                                            required
                                            value={formData.email}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <input
                                            type="text"
                                            placeholder="Phone No*"
                                            id="mobile_number"
                                            name="mobile_number"
                                            required
                                            value={formData.mobile_number}
                                            onChange={handleChange}
                                            maxLength={10}
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <input
                                            type="text"
                                            placeholder="Subject*"
                                            id="subject"
                                            name="subject"
                                            required
                                            value={formData.subject}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="col-md-12">
                                        <textarea
                                            name="message"
                                            id="message"
                                            cols="30"
                                            rows="5"
                                            placeholder="Message"
                                            required
                                            value={formData.message}
                                            onChange={handleChange}
                                        ></textarea>
                                    </div>

                                    <div className="col-md-12">
                                        <button
                                            className="btn-cstm web_buttons"
                                            disabled={loading}
                                            type="submit"
                                        >
                                            {loading ? (
                                                <ClipLoader color="#fff" size={20} />
                                            ) : (
                                                "Submit"
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </>
    );
};

export default ContactUs;
